/**
 *
 * @module views/components/HeroWrapper
 * @memberof -Common
 */
import React from 'react';

import PropTypes from 'prop-types';

import Hero from '@ulta/core/components/Hero/Hero';
import { spreadProps } from '@ulta/core/utils/dom/dom';

import FullBleedHeroCompact from '../FullBleedHeroCompact/FullBleedHeroCompact';

/**
* Represents a HeroWrapper component
*
* @method
* @param {HeroWrapperProps} props - React properties passed from composition
* @returns HeroWrapper
*/
export const HeroWrapper = function( props ){

  const { variant } = props;

  if( variant === FULL_BLEED_COMPACT_HERO ){
    return <FullBleedHeroCompact { ...spreadProps( { ...props } ) } />;
  }

  return <Hero { ...spreadProps( { ...props } ) } />;
};

/**
 * @const {string} FULL_BLEED_HERO_COMPACT - option for full bleed compact hero
 */
export const FULL_BLEED_COMPACT_HERO = 'fullBleedCompactHero';

/**
 * Property type definitions
 * @typedef FullBleedHeroCompactProps
 * @type {object}
 * @property {object} actionGroups - Sets actions for the component.
 * @property {string} backgroundColor - Sets the background color.
 * @property {string} body - Sets the body text.
 * @property {string} bodySecondLine - Sets the second line of body text.
 * @property {string} eyebrow - Sets the eyebrow text.
 * @property {string} headline - Sets the headline text.
 * @property {string} headlineTag - Sets the HTML tag for the headline.
 * @property {object} image - Sets the desktop image.
 * @property {object} mobileImage - Sets the mobile image.
 * @property {object} tabletImage - Sets the tablet image.
 * @property {object} tag - Sets the tag properties.
 * @property {string} textColor - Sets the text color.
 * @property {string} textPosition - Sets the text alignment.
 * @property {string} variant - Sets the component variant.
 */
export const propTypes = {
  actionGroups: PropTypes.object,
  backgroundColor: PropTypes.string,
  body: PropTypes.string,
  bodySecondLine: PropTypes.string,
  eyebrow: PropTypes.string,
  headline: PropTypes.string,
  headlineTag: PropTypes.string,
  image: PropTypes.object,
  mobileImage: PropTypes.object,
  tag: PropTypes.object,
  tabletImage: PropTypes.object,
  textColor: PropTypes.string,
  textPosition: PropTypes.string,
  variant: PropTypes.string
};

HeroWrapper.propTypes = propTypes;

export default HeroWrapper;